export default __webpack_public_path__ + "fonts/offer-automator-logo.svg";